<!-- 测评中心- -->
<template>
  <div class="ceping-category-add">
    <van-form class="wrap" input-align="right">
      <van-field
        v-model="name"
        type="text"
        maxlength="20"
        placeholder="请输入，20个字以内"
        label="测评项目类型"
        input-align="right"
        :formatter="v => v.trim()"></van-field>
    </van-form>
    <pageFooterBtn btnText="确定" @click="submitCepingCategory"/>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'cepingCategoryAdd',
  data() {
    return {
      pageTitle: '新增项目类型',
      name: '',
      id: '',
      scene: this.$vxRoute.query.scene || ''
    }
  },
  methods: {
    async submitCepingCategory() {
      if (!this.name){
        this.$toast.fail('请输入测评类型');
         return;
      }
      this.showLoading();
      let res = {};
      if(this.scene == "edit") {
        res = await this.$api.evaluationItemTypeUpdate({
          id: this.id,
          name: this.name
        });
      } else {
        res = await this.$api.evaluationItemTypeAdd({
          name: this.name
        });
      }
      if (res.code == 200) {
        this.$toast.success(this.scene == "edit" ? '修改成功' : '新增成功');
        setTimeout(() => {
          app.vue.$emit("refresh-ceping-category-setting");
          this.$router.back();
        }, 500);
      } else {
        this.$toast.fail(res.msg);
      }
    }
  },
  created() {
    if (this.scene == "edit") {
      this.pageTitle = '修改项目类型';
      this.id = this.$route.query.id;
      this.name = this.$route.query.name;
    }
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss" scoped>
.ceping-category-add {
  display: flex;
  flex-direction: column;
  .wrap {
    flex: 1;
  }
}
</style>